import Footer from "../../components/Footer";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import { requestDeleteData } from "../../api";

export const DeleteData = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: '',
        description: ''
    });
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        requestDeleteData({
            email: formData.email,
            description: formData.description
        })
            .then(() => {
                setSubmitted(true);
                setFormData({ email: '', description: '' });
            })
            .catch(() => {
                setError('Something went wrong. Please try again later.');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="App">
            <nav className="navbar">
                <div className="nav-container">
                    <div className="nav-logo">
                        <h2>AI Cards: Learn &amp; Speak</h2>
                    </div>
                    <div className="nav-links">
                        <button onClick={() => navigate('/')} className="nav-link">Home</button>
                    </div>
                </div>
            </nav>

            <section className="contact-section">
                <div className="container">
                    <div className="contact-layout">
                        <h2>Delete My Data</h2>
                        <p>
                            Submit a request to permanently remove all your personal data from our
                            system. We will process your request within 30 days.
                        </p>

                        {submitted ? (
                            <div className="delete-success-card">
                                <span className="delete-success-icon">✓</span>
                                <h3>Request Received</h3>
                                <p>
                                    We have received your data deletion request. You will receive
                                    a confirmation email shortly, and we will process your request
                                    within 30 days.
                                </p>
                                <button
                                    className="nav-link"
                                    style={{ marginTop: '24px' }}
                                    onClick={() => navigate('/')}
                                >
                                    Back to Home
                                </button>
                            </div>
                        ) : (
                            <form className="contact-form" onSubmit={handleSubmit}>
                                <div className="delete-warning-banner">
                                    ⚠️&nbsp; This action is <strong>irreversible</strong>. All your account
                                    data, progress, and history will be permanently deleted.
                                </div>

                                <div className="form-group">
                                    <label htmlFor="email">Email Address</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        placeholder="Enter the email linked to your account"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="description">
                                        Additional Information <span style={{ fontWeight: 400, color: 'var(--text-muted)' }}>(optional)</span>
                                    </label>
                                    <textarea
                                        id="description"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        placeholder="Let us know why you'd like to delete your data, or any additional details…"
                                        rows="4"
                                    />
                                </div>

                                {error && (
                                    <p style={{ color: 'var(--error)', marginBottom: '16px', fontSize: '0.95rem' }}>
                                        {error}
                                    </p>
                                )}

                                <button
                                    type="submit"
                                    className="submit-button delete-submit-button"
                                    disabled={loading}
                                >
                                    {loading ? 'Submitting…' : 'Submit Deletion Request'}
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};
